import * as React from 'react'
import ReactDOM from 'react-dom'

import Landing from './components/Landing'
import HamburgerMenu from './components/HamburgerMenu'
import TitleDetails from './components/TitleDetails'

interface VMTitleVideo {
    title: string
    description: string
    coverImage: string
    video: string
    footer: string
    videoDuration: string
    category: string
    moderator: string
}
interface VMTitleListen {
    title: string
    description: string
    file: string
    footer: string
}
interface VMTitleRead {
    title: string
    description: string
    file: string
    footer: string
    filesize: number
}

export interface VMTitleCategorySong {
    name: string
    composer: string
    file: string
}

interface VMTitleCategory {
    type: string
    label: string
    text?: string
    song?: VMTitleCategorySong[]
}

export interface VMTitle {
    id: number
    image: string
    url: string
    title: string
    trailerVideo: string
    trailerCover: string
    synopsis: string
    gallery: string[]
    accolades: string[]
    categoriesComingSoon: boolean
    categories: VMTitleCategory[]
    indepthComingSoon: boolean
    videos: VMTitleVideo[]
    read: VMTitleRead[]
    listen: VMTitleListen[]
    prevTitle: string
    nextTitle: string
    titleImage: string
    titleImageMenu: string
    rsvpComingSoon: boolean
    watchNowURL: string
    watchNowImage: string
}
interface VMC {
    id?: number
    titles?: VMTitle[]
}

declare var vmc: VMC

document.addEventListener('DOMContentLoaded', () => {
    console.log('vmc', vmc)

    const titles = vmc.titles ? vmc.titles : []

    const titleBody = document.getElementById('title-content')
    titleBody &&
        ReactDOM.render(<TitleDetails titleData={titles.filter((title) => title.id == vmc.id)[0]} />, titleBody)

    const mouseFocusWrapper = document.getElementById('mouse-focus')
    mouseFocusWrapper && ReactDOM.render(<Landing sliderItems={titles} />, mouseFocusWrapper)

    const hamburgerMenuWrapper = document.getElementById('hamburger-menu-wrapper')
    hamburgerMenuWrapper && ReactDOM.render(<HamburgerMenu menuItems={titles} />, hamburgerMenuWrapper)
})
